<template>
  <v-row justify="center">
    <v-dialog v-model="uploadDialog" persistent max-width="480">
      <v-card>
        <v-card-title>
          {{ uploadDialogTitle }}
        </v-card-title>
        <v-card-text
          ><v-file-input
            ref="inputFile"
            :accept="fileInputAccept"
            label="เลือก file"
            @change="selectedFile"
            outlined
            dense
          ></v-file-input>
          <p>
            ดาวน์โหลดตัวอย่างไฟล์
            <a
              :href="downloadExampleFileImportDataUrl"
              :download="downloadExampleFileImportDataName"
              >{{ downloadExampleFileImportDataName }}</a
            >
          </p>
        </v-card-text>
        <v-card-actions class="px-6 pb-5">
          <v-btn color="primary" @click="uploadFile">
            ตกลง
          </v-btn>
          <v-btn @click="handleCancelUploadDialog">
            ยกเลิก
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: {
    uploadDialog: {
      type: Boolean,
      default: false
    },
    uploadDialogTitle: {
      type: String,
      default: 'นำเข้าข้อมูล'
    },
    fileInputAccept: {
      type: String,
      default: '.csv'
    },
    downloadExampleFileImportDataUrl: {
      type: String,
      required: true
    },
    downloadExampleFileImportDataName: {
      type: String,
      required: true
    }
  },
  methods: {
    selectedFile(file) {
      this.$emit('selectedFile', file)
    },
    handleCancelUploadDialog() {
      this.$emit('handleCancelUploadDialog', this.$refs.inputFile)
    },
    uploadFile() {
      this.$emit('uploadFile', this.$refs.inputFile)
    }
  }
}
</script>
